import { Component, Input } from '@angular/core';
import { UserType } from 'src/app/modules/auth/models/UserType';
import { AuthService } from 'src/app/modules/auth/services/auth.service';

@Component({
	selector: 'app-avatar',
	templateUrl: './avatar.component.html',
	styleUrls: ['./avatar.component.scss']
})
export class AvatarComponent {

	img! : string;
	@Input() size!: string;

	constructor(private auth: AuthService) {
		this.auth.oUser.subscribe(
			(u:UserType) => {
				if (u?.photo)
					this.img = u.photo;
				else
					this.img = "/assets/img/image-not-found.svg";
			}
		)
	}
}